export default "__VITE_ASSET__2c76c842__"